<div style="width: 100%;">
    <div style="margin: 20px;">
        <span i18n="@@input-dialog-example.title" >
            Are you sure you want to Manually Acknowledge this record? When submitted, this action can not be reversed.
        </span>
    </div>
    <div class="import-dialog-actions" style="display: flex; justify-content: flex-end; gap: 12px; margin: 20px;">
        <owc-button class="cancel-button" one-secondary-button title="Cancel" (click)="sendConfirmation('false')" tabindex="-1">Cancel</owc-button>
        <owc-button color="primary" title="Submit" (click)="sendConfirmation('true')" tabindex="-1">Submit</owc-button>
    </div>
</div>
